/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DecideAgentRunMcpApprovalRequest = {
  approvalRequestId: string;
  approve: boolean;
  reason?: string | undefined;
};

/** @internal */
export const DecideAgentRunMcpApprovalRequest$inboundSchema: z.ZodType<
  DecideAgentRunMcpApprovalRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  approval_request_id: z.string(),
  approve: z.boolean(),
  reason: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "approval_request_id": "approvalRequestId",
  });
});
/** @internal */
export type DecideAgentRunMcpApprovalRequest$Outbound = {
  approval_request_id: string;
  approve: boolean;
  reason?: string | undefined;
};

/** @internal */
export const DecideAgentRunMcpApprovalRequest$outboundSchema: z.ZodType<
  DecideAgentRunMcpApprovalRequest$Outbound,
  z.ZodTypeDef,
  DecideAgentRunMcpApprovalRequest
> = z.object({
  approvalRequestId: z.string(),
  approve: z.boolean(),
  reason: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    approvalRequestId: "approval_request_id",
  });
});

export function decideAgentRunMcpApprovalRequestToJSON(
  decideAgentRunMcpApprovalRequest: DecideAgentRunMcpApprovalRequest,
): string {
  return JSON.stringify(
    DecideAgentRunMcpApprovalRequest$outboundSchema.parse(
      decideAgentRunMcpApprovalRequest,
    ),
  );
}
export function decideAgentRunMcpApprovalRequestFromJSON(
  jsonString: string,
): SafeParseResult<DecideAgentRunMcpApprovalRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DecideAgentRunMcpApprovalRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DecideAgentRunMcpApprovalRequest' from JSON`,
  );
}
